import React, { Component } from 'react';
import { connect }          from 'react-redux';
import {GetCheckSelect}  from '../actions/scopoAction';

class Topo extends Component {
    render() {
        const zIndex = {zIndex:100}
        const cusor = {'cursor': 'pointer'}
        return (
           <header className="hud-middle-center-header" style={zIndex}>
                    <div className="hud-quick-action hud-quick-action-left hud-quick-action-active">
                        {this.props.menu1 ? <a href={void(0)} onClick={()=>this.props.GetCheckSelect((this.props.menu1Valeu?this.props.menu1Valeu:null))} style={cusor}>{this.props.menu1} </a> : ""}
                    </div>
                    <div className="hud-title">
                       {this.props.titulo}
                    </div>
                    <div className="hud-quick-action hud-quick-action-right hud-quick-action-active">
                       {this.props.menu1 ? <a href={void(0)} onClick={()=>this.props.GetCheckSelect((this.props.menu2Value?this.props.menu2Value:1))} style={cusor}> {this.props.menu2}</a> : ""}
                    </div>
                </header>
        );
    }
}


function mapStateToProps(state){  
    return { menu : state.configReducer.menu};
}

export default connect(mapStateToProps,{GetCheckSelect})(Topo);




// WEBPACK FOOTER //
// ./src/container/RenderTopoPag.js